export enum UserType {
  Candidate = "CANDIDATE",
  Consultant = "CONSULTANT",
  Contractor = "CONTRACTOR",
  Employee = "EMPLOYEE",
  Customer = "CUSTOMER",
  Payee = "PAYEE",
  New = "NEW",
  All = "ALL"
}

export enum TreeViewType {
  ChartOfAccount = "CHART_OF_ACCOUNT",
  ContractSummary = "CONTRACT_SUMMARY",
  GeneralLedger = "GENERAL_LEDGER",
  ItemCatalog = "ITEM_CATALOG",
  ItemCatalogSummary = "ITEM_CATALOG_SUMMARY",
  ItemCatalogBom = "ITEM_CATALOG_BOM",
  Project = "PROJECT_TASK",
  ProjectBalance = "PROJECT_BALANCE",
  ProjectCatalog = "PROJECT_CATALOG",
  TaskBalance = "TASK_BALANCE",
  TrialBalance = "TRIAL_BALANCE"
}

export enum TreeViewId {
  ChartOfAccount = -1,
  ContractSummary = -2,
  GeneralLedger = -3,
  ItemCatalog = -4,
  ItemCatalogSummary = -5,
  ProjectBalance = -6,
  ProjectCatalog = -7,
  TaskBalance = -8,
  TrialBalance = -9
}

export enum TreeViewNodeId {
  TrialBalance = "fiscalYearLedgerAccountId"
}
